function addFiltersEventListeners(e) {
  $a(".filter-heading").forEach((element) => {
    element.addEventListener("click", (e) => toggleFilterVisibility(e));
  });

  $a(".filter-panel__open").forEach((element) => {
    element.addEventListener("click", (e) => openFiltersPanelMobile(e));
  });

  x(".filters-panel__close")?.addEventListener("click", (e) => {
    resetNextFilters();
    closeFiltersPanelMobile(e);
  });

  $a(".filter-trigger").forEach((element) =>
    element.addEventListener("click", (e) => switchTrigger(e))
  );

  x(".filters-panel__footer .button__apply-filters")?.addEventListener(
    "click",
    (e) => {
      closeFiltersPanelMobile(e);
      applyFilters();
    } //funzione in helpers.js che si occupa di applicare i filtri selezionati
  );

  x(".filters-panel__footer .button__cancel-filters")?.addEventListener(
    "click",
    (e) => {
      closeFiltersPanelMobile(e);
      resetNextFilters();
    } //funzione in helpers.js che si occupa di applicare i filtri selezionati
  );
}

function toggleFilterVisibility(e) {
  if (e.target) {
    let selectedId = e.target.getAttribute("data-target");
    if (!selectedId) {
      return;
    } else {
      if (e.target.classList.contains("expanded")) {
        e.target.classList.remove("expanded");
        collapseFilters(e, selectedId);
      } else {
        e.target.classList.add("expanded");
        expandFilters(e, selectedId);
      }
    }
  }
}

function collapseFilters(e, selectedId) {
  let divider = x(`.filter-divider-${selectedId}`);
  let container = x(`.filter-container-${selectedId}`);
  let filterIcon = e.target.querySelector(`.filter-icon`);
  let filterItems = Array.from(container.querySelectorAll(".filter-item"));

  let tl = gsap.timeline();

  gsap.to(filterIcon, {
    rotate: "0deg",
    duration: shopUtils.animations ? 0.3 : 0,
  });

  let outerIndex = 0;
  for (let index = filterItems.length; index > 0; index--) {
    const element = filterItems[index];
    gsap.to(element, {
      opacity: 0,
      duration: shopUtils.animations ? 0.06 : 0,
      delay: shopUtils.animations ? outerIndex * 0.02 : 0,
    });
    outerIndex++;
  }
  tl.to(container, {
    height: "0px",
    marginBottom: 0,
    duration: shopUtils.animations ? 0.3 : 0,
  });
  tl.to(divider, {
    width: "0%",
    duration: shopUtils.animations ? 0.3 : 0,
    delay: shopUtils.animations ? 0.3 : 0,
  });
}

function expandFilters(e, selectedId) {
  let divider = x(`.filter-divider-${selectedId}`);
  let container = x(`.filter-container-${selectedId}`);
  let filterIcon = e.target.querySelector(`.filter-icon`);
  let filterItems = Array.from(container.querySelectorAll(".filter-item"));

  filterItems.forEach((element) => {
    element.style.opacity = "0";
  });

  let tl = gsap.timeline();
  gsap.to(filterIcon, {
    rotate: "180deg",
    duration: shopUtils.animations ? 0.1 : 0,
  });
  tl.to(divider, { width: "100%", duration: shopUtils.animations ? 0.3 : 0 });
  tl.to(container, {
    height: "auto",
    marginBottom: "5rem",
    duration: shopUtils.animations ? 0.3 : 0,
  });

  filterItems.forEach((element, index) => {
    gsap.fromTo(
      element,
      { x: -10, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: shopUtils.animations ? 0.3 : 0,
        delay: shopUtils.animations ? index * 0.05 : 0,
      }
    );
  });
}

function closeFiltersPanelMobile(e) {
  let filterPanel = x(".filters-panel__mobile");
  let filterPanelWrapper = x(".filters-panel__mobile-wrapper");
  let filtersIcon = $a(".filters-container__mobile .filter-icon");

  filtersIcon.forEach((element) => {
    gsap.to(element, { rotate: "-90deg" });
  });

  let tl = gsap.timeline();
  tl.to(filterPanel, {
    right: "-100vw",
    duration: shopUtils.animations ? 0.3 : 0,
  });
  tl.to(filterPanelWrapper, {
    opacity: 0,
    duration: shopUtils.animations ? 0.1 : 0,
  });
  gsap.to(filterPanelWrapper, {
    right: "-100vw",
    delay: shopUtils.animations ? 0.35 : 0,
  });
}

function openFiltersPanelMobile(e) {
  let filterPanel = x(".filters-panel__mobile");
  let filterPanelWrapper = x(".filters-panel__mobile-wrapper");
  let filterIcon = e.target.querySelector(".filter-icon");

  let tl = gsap.timeline();
  gsap.to(filterIcon, { rotate: "90deg" });
  tl.to(filterPanelWrapper, {
    right: "0vw",
    duration: shopUtils.animations ? 0.1 : 0,
  });
  tl.to(filterPanelWrapper, {
    opacity: 1,
    duration: shopUtils.animations ? 0.2 : 0,
  });
  tl.fromTo(
    filterPanel,
    { right: "-100vw" },
    { right: "0vw", duration: shopUtils.animations ? 0.3 : 0 }
  );

  let selectedId = e.target.getAttribute("data-target");
  let filtersPanel = $a(".filter-panel");

  filtersPanel.forEach((element) => {
    if (element.id == `filter-panel__${selectedId}`) {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  });

  if (selectedId == 0) {
    x(".filters-panel__footer .button--primary").style.display = "none";
  } else {
    x(".filters-panel__footer .button--primary").style.display = "flex";
  }

  let filterPanelHeading = e.target.querySelector("div:nth-child(1)").innerHTML;
  x(".filters-panel__header div:nth-child(1)").innerHTML = filterPanelHeading;
}

function switchTrigger(e) {
  triggerFilter(e); //funzione in helpers.js
}
